import React, {useState} from 'react';
import Card from "../components/card/card";
import Filter from "../components/filter";
import CoverLoading from "../components/cover-loading";
import {Link} from "react-router-dom";


const GroupTours = () => {
    const [post,setPost] = useState([])
    const [loading,setLoading] = useState(false)
    return (
        <div className='main-container justify-content-start'>
            {loading ? <CoverLoading/> : ''}
            <Filter path='group-tour' setPost={setPost} setLoading={setLoading}/>
            <div className="row justify-content-end">
                <div className="col-2">
                    <Link to={'/add-group-tour'} className='btn btn-primary'>Create Group Tour</Link>
                </div>
            </div>
            <div className="list-posts">
                {post.map((e)=><Card path='group-tour' post={post} setPost={setPost} setLoading={setLoading} key={e.id} data={e}/>)}
            </div>
        </div>
    );
};

export default GroupTours